<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


	<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 核价确认</Button>
	<Button class="submit-process" v-on:click='refuse' v-bind:loading="formLoading" size="large" type="primary"> 驳回
	</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate,

		GetPendingProcessById
	} from '@/api/approval'
  // getMediaId,
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
	  title: null,
	  url: null,
	  toUser: [],
	  desc: null,
	  template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				applyTemplateData:null,
				sendMessageData:{},
				flowId:null
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values=[];
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},

			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var thar = this;
				await GetPendingProcessById(this.flowId).then(response =>{
					if(response.Body==null){
						this.Message({
							message: '该流程已经处理完成',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/Pricing");
						}, 1000)
						return;
					}
				})
				
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					await thar.getFlowTemplateInfo();
					controls.TemplateContent.Controls.forEach(async (item,index) => {
						var departs = thar.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "请选择审批流程") {
							item.Disable=true;
							item.IsShow=false;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "请选择审批流程"})[0].Value
							}
						}
						// if (item.Property.Title[0].Text == "申请人员部门") {
						// 	item.Disable=true;
						// 	item.IsShow=false;
						// }
						if (item.Property.Title[0].Text == "合计") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "合计"})[0].Value
							}
						}
						
						if (item.Property.Title[0].Text == "行政主任") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "行政主任"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "行政经理") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "行政经理"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "小战区区董") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "小战区区董"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大战区区董") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "大战区区董"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "经理/总监")
						{
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "经理/总监"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "总经理") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "总经理"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "关联申请单") {
							if(thar.spNo!=null){
								item.Value = thar.spNo;
							}
						}
						if (item.Property.Title[0].Text == "维修") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								var control=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "维修"})[0];
								if(control!=null){
									item.Value=control.Value;
								}else{
									item.IsShow=false;
								}
							}
							
						}
						if (item.Property.Title[0].Text == "申请原因") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请原因"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请类别1") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请类别1"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请类别2") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请类别2"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "配送地点") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "配送地点"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "收货人联系方式") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "收货人联系方式"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "配送到位时间") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "配送到位时间"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "备注") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "备注"})[0].Value;
							}
						}

						if (item.Property.Title[0].Text == "合计") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "合计"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请人员") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								var empName=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "姓名"})[0].Value;
								var empNo=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "工号"})[0].Value;
								item.Values=[[empNo,empName]];
								item.Value=empName;
							}

						}
						if (item.Property.Title[0].Text == "申请人员工号") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "工号"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请人部门") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "逐级审批") {
							item.IsShow = false;
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "逐级审批"})[0].Values;
							}
						}
						if (item.Property.Title[0].Text == "申请人职位") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "职位"})[0].Value;
							}
						}
						
						if (item.Property.Title[0].Text == "申请部门") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "核价人部门") {
							item.Disable=true;
							item.Value=thar.logInfo.DeptName;
						}
						if (item.Property.Title[0].Text == "核价人职位") {
							item.Disable=true;
							item.Value=thar.logInfo.PositionName;
						}
						if (item.Property.Title[0].Text == "核价人员") {
							item.Disable=true;
							item.Value=thar.logInfo.EmpName
						}
						if (item.Property.Title[0].Text == "核价人工号") {
							item.Disable=true;
							item.Value=thar.logInfo.EmpNo
						}
						
						if (item.Property.Title[0].Text == "申请项目内容") {
							item.Config.Table.Children.forEach(e =>{
								e.Disable = true;
							})
						}
						
					});
					
					thar.templateData = thar.assignControl(controls, thar.logInfo);
					thar.templateData = await thar.assignControlBySpNo(controls, thar.spNo, thar.flowId,true);
					thar.listLoading = false;
					
					await thar.templateData.TemplateContent.Controls.forEach(async (item) => {
						
						if (item.Property.Title[0].Text == "供应商信息") {
							// item.addIsShow = true;
							thar.$set(item, "addIsShow", true);
						}
						if (item.Property.Title[0].Text.indexOf("申请项目内容")>-1) {
							item.Config.Table.Children.forEach(e =>{
								e.Disable = false;
							})
							thar.$set(item, "addIsShow", true);
						}
					});
				});

			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getFlowTemplateInfo: async function() {
				if(this.flowId==null||this.flowId==undefined||this.flowId.length<=0){
						return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				if(name=="类别"){
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "维修" && val.indexOf(item.Key) > -1;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "维修")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			refuse(){
				var controls = this.templateData.TemplateContent.Controls;
				var applyEmpNo = '';
				controls.forEach(e =>{
					if (e.Property.Title[0].Text == "申请人员工号") {
						applyEmpNo = e.Value;
					}
				})
				this.sendMessageData.Template=this.templateData;
				this.sendMessageData.Title="行政采购申请";
				this.sendMessageData.ToUser= [applyEmpNo];
				this.sendMessageData.Desc="驳回人员："+this.logInfo.EmpName;
				this.sendMessageData.Url=document.location.hostname+"/AdministrativeProcurementApplication?templateId=Bs7yobXi5T5YzUx2vgBKFCNvvEQ8tvyQMM3v3MhCu&flowId="+this.flowId;
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData,2,"",this.flowId).then(response => {
					this.Message({
						message: '驳回成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
				});
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				
				isSubmit = true;
				this.listLoading = true;
				var empNo = '';
				this.templateData.TemplateContent.Controls.forEach(e=>{
					if(e.Property.Title[0].Text == "申请人员工号"){
						empNo = e.Value;
					}
				})
				
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人员"})[0]
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人员工号"})[0]
				var control5=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人部门"})[0]
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人信息："+control.Value+" "+control4.Value+" "+control5.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请表别称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				info.SummaryInfo.push({"Text":"申请表别称："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "确认价格"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"确认价格："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList;
				
				//提交
				submitProcess(this.templateId, empNo, this.spNo, this.templateData,this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/Pricing");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
